<template>
  <div class="product-card" :class="`layout-${layout}`" @click="handleClick">
    <div class="product-card__image">
      <img :src="product.headImage || ''" :alt="product.title" />
    </div>
    <div class="product-card__body">
      <div class="product-card__title">{{ product.title }}</div>
      <div class="product-card__price">
        <template v-if="hasPrice">¥{{ product.minPrice }}<span class="product-card__price-unit">起</span></template>
        <span v-else class="product-card__price-empty">敬请期待</span>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    // list：单列大图，固定图高裁切（首页用）；grid：两列网格，固定图高裁切（产品列表页用）
    layout: {
      type: String,
      default: 'list'
    }
  },
  computed: {
    hasPrice() {
      const price = this.product && this.product.minPrice
      return price !== null && price !== undefined && Number(price) > 0
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.product)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.98);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  &__image {
    width: 100%;
    height: 180px;
    background: #f3f4f6;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &.layout-grid {
    .product-card__image {
      height: 110px;
    }

    .product-card__body {
      padding: 8px;
    }

    .product-card__title {
      font-size: 13px;
    }
  }

  &__body {
    padding: 12px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 6px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__price {
    font-size: 14px;
    font-weight: 700;
    color: #ff6b35;
    line-height: 1.3;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__price-unit {
    font-size: 12px;
    font-weight: 400;
    margin-left: 1px;
  }

  &__price-empty {
    font-size: 13px;
    font-weight: 400;
    color: #9ca3af;
  }
}
</style>
